import { installThemeColour } from "@groundspark/styles/colours";
import "@groundspark/styles/branch";
import { element, heading } from "@groundspark/browser-ui";
import { BranchApplication } from "./app";
import { AuthManager } from "./auth";
import { readConfig } from "./config";

installThemeColour(document);
const root = document.querySelector<HTMLElement>("#app");
if (root === null) throw new Error("The branch application root element is missing.");

try {
  await new BranchApplication(root, new AuthManager(readConfig())).start();
} catch (error) {
  root.replaceChildren(
    element(
      "main",
      "centred-screen",
      element(
        "section",
        "message-card",
        heading(1, "Branch management could not start", "message-card__title"),
        element("p", "muted", error instanceof Error ? error.message : String(error)),
      ),
    ),
  );
}
